// extracted by mini-css-extract-plugin
export default {"label":"EventInstanceRow_label__NMrVo","removable":"EventInstanceRow_removable__27jEI"};